import { render, staticRenderFns } from "./RefundTotalDetails.vue?vue&type=template&id=9ffbaac0&"
import script from "./RefundTotalDetails.vue?vue&type=script&lang=js&"
export * from "./RefundTotalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports